import { ConfirmModal } from './ConfirmModal';
import { useRestoreUser } from '../hooks';

interface Props {
  open: boolean;
  userId: string;
  userName?: string;
  onClose: () => void;
}

export function RestoreUserModal({ open, userId, userName, onClose }: Props) {
  const mutation = useRestoreUser();
  return (
    <ConfirmModal
      open={open}
      title={`Restore ${userName ?? 'user'}?`}
      description="The user will regain access immediately."
      confirmLabel="Restore"
      loading={mutation.isPending}
      onClose={onClose}
      onConfirm={async () => {
        await mutation.mutateAsync(userId);
        onClose();
      }}
    >
      {mutation.error && (
        <p className="text-xs text-red-300">{(mutation.error as Error).message}</p>
      )}
    </ConfirmModal>
  );
}
